import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import "./styles/text.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProviders } from "AppProviders";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/ _jsx(AppProviders, {
    children: /*#__PURE__*/ _jsx(App, {})
}));
reportWebVitals();
